var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is_sdp_v2)?_c('ShowDetails'):_vm._e(),_vm._v(" "),(_vm.is_sdp_v2)?_c('ShowDetailsV2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }